// No contexto cliente, alguns módulos abrem um modal focado no cliente ativo em
// vez de navegar para uma página (ex.: no CRM, abrir o modal cliente-360 do cliente).
// Este helper decide, de forma pura, se o clique num item de navegação deve abrir
// esse modal — a emissão do evento e o host do modal ficam a cargo de quem chama.
//
// Todas as condições são obrigatórias:
//   - estamos no contexto cliente (isCliente)
//   - o item declara clienteModal (marcador em CLIENTE_GROUPS)
//   - o item NÃO está em upsell (noAccessIcon): sem acesso mantém a landing de
//     cross-sell (mesmo critério do clienteSkipTo em resolve-dynamic-route)
//   - há um cliente ativo com id: sem cliente não há foco possível, então deixamos
//     o fluxo de navegação/fallback (clienteSkipTo) assumir

/**
 * @param {Object} item item da nav (pode ter item.clienteModal / item.noAccessIcon)
 * @param {Object} ctx
 * @param {boolean} ctx.isCliente contexto cliente ativo
 * @param {Object}  ctx.client    cliente ativo ($currentClient())
 * @returns {boolean}
 */
export function shouldOpenClienteModal(item, ctx = {}) {
  if (!ctx.isCliente) return false
  if (!item || !item.clienteModal || item.noAccessIcon) return false
  const { client } = ctx
  return !!(client && client.id)
}
